module.exports = __webpack_public_path__ + "static/media/SchirattiMariaeRosa.9c766da4.jpg";